import en from './en';
import es from './es';
import esES from './es-ES';
import da from './da';
import fr from './fr';
import it from './it';

export default {
  en,
  es,
  'es-ES': esES,
  da,
  fr,
  it,
};



// WEBPACK FOOTER //
// ./src/locales/data.js